import { Box, styled } from '@material-ui/core';

export const Container = styled(Box)({
  height: '100%',
  overflow: 'hidden',
  flex: 1,
  display: 'flex',
  flexDirection: 'column'
});

export const Content = styled(Box)({
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  overflow: 'hidden auto'
});

export const GrayBox = styled(Box)({
  background: '#F0F0F4',
  borderRadius: 12,
  padding: 12,

  // Style paragraphs
  '& p': {
    fontSize: 16
  },

  // Style unordered list
  '& ul': {
    fontSize: 16
  },

  // Style list items
  '& ul li': {
    fontSize: 16
  }
});
